import {NotificationReceiver} from './NotificationReceiver'

export default class MeetingNotificationReceiveSetting {
    condominiumCd: string
    condominiumName: string
    condominiumGroupName: string
    condominiumMailAddressList: string[]
    receiverList: NotificationReceiver[]
    isReceive: boolean

    constructor(
        condominiumCd: string,
        condominiumName: string,
        condominiumGroupName: string,
        condominiumMailAddressList: string[],
        receiverList: NotificationReceiver[],
        isReceive: boolean,
    ) {
        this.condominiumCd = condominiumCd
        this.condominiumName = condominiumName
        this.condominiumGroupName = condominiumGroupName
        this.condominiumMailAddressList = condominiumMailAddressList
        this.receiverList = receiverList
        this.isReceive = isReceive
    }

    static from(json: any): MeetingNotificationReceiveSetting {
        return new MeetingNotificationReceiveSetting(
            json.condominiumCd,
            json.condominiumName,
            json.condominiumGroupName,
            json.condominiumMailAddressList,
            json.receiverList.map((receiver: any) => NotificationReceiver.from(receiver)),
            json.isReceive,
        )
    }
}
